module.exports = __webpack_public_path__ + "omniv2/img/icon-trim.1e20a239.svg";